import { inject } from "@angular/core";
import { AuthStore } from "@core/services/auth.store";

/**
 * Application initializer that checks if the user is authenticated.
 * Routes are protected by guards that will redirect to login if the user is not authenticated.
 * The initializer will attempt to fetch the current user profile, which will succeed if the user has a valid session cookie.
 * If the session is invalid or expired, it will clear the user state and allow the guards to handle redirection to the login page.
 * @returns Promise that resolves when the authentication check is complete
 */
export const authInitializer = () => {
  const authStore = inject(AuthStore);
  return authStore.init();
};
